import { TravelPurpose } from '../constants';
import request from '../request';

export type Source = 'WEB' | 'IOS_WEB' | 'ANDROID_WEB' | 'OTHER';

type Room = {
  adultMaleCount: number;
  adultFemaleCount: number;
  seniorElementarySchoolChildCount: number;
  juniorElementarySchoolChildCount: number;
  infantWithMealCount: number;
  infantWithFutonCount: number;
  infantWithMealAndFutonCount: number;
  infantWithoutMealAndFutonCount: number;
};

type RequestPlan = {
  date: string;
  planCode?: string;
};

type RequestData = {
  firstName: string;
  lastName: string;
  firstNameKana: string;
  lastNameKana: string;
  phoneNumber: string;
  email: string;
  emailConfirmation: string;
  countryCode: string;
  prefecture: string;
  postalCode: string;
  address: string;
  specialRequest: string;
  paymentMethod: string;
  totalAmount: number;
  discountedPrice?: number;
  propertyId: string;
  roomTypeCode: string;
  rooms: Room[];
  plans: RequestPlan[];
  trackingId: string;
  guestArrivalTime: string;
  travelPurpose: TravelPurpose;
  source: Source;
  accountId?: string;
  idToken?: string;
  language: string;
  affiliate?: {
    a8?: string;
  };
  affiliate_id?: string;

  discountCodes?: string[]; // for voucherify coupon codes
  promotionIds?: string[]; // for voucherify campaigns
  couponIds?: number[]; // for interal coupon codes
  discountId?: number; // for strapi camapign id
  zenkokuId?: number;
};

type CancelPenalty = Partial<{
  type: string;
  deadline: number | null;
  percentage: number | null;
  amount: number | null;
}>;

type PlanPenalties = Partial<{
  penaltyDescription: string;
  cancelPenalties: CancelPenalty[];
}>;

type Plan = Partial<{
  planCode: string;
  stayDate: string;
  planName: string;
  description: string;
  planImageUrl: string;
  breakfast: boolean;
  lunch: boolean;
  dinner: boolean;
  planPenalties: {
    penaltyDescription: string;
    cancelPenalties: PlanPenalties[];
  };
  forecastCancellationFee: Record<string, never>;
}>;

type ResponseData = Partial<{
  bookingId: string;
  bookingStatus: string;
  checkInDate: string;

  /**
   * e.g. 18:00
   */
  checkInTime: string;

  checkOutDate: string;

  /**
   * e.g. 10:00
   */
  checkOutTime: string;
  guestArrivalTime: string;
  totalAmount: number;
  totalDiscountAmount?: number;
  totalPreviousAmount?: number;
  totalCancellationAmount?: number;
  rooms: Partial<Room>[];
  payment: {
    paymentMethod: string;
    status: string;
    trackingId: string;
  };
  customer: {
    firstName: string;
    lastName: string;
    firstNameKana: string;
    lastNameKana: string;
    email: string;
    phoneNumber: string;
    postalCode: string;
    address: string;
    countryCode: string;
    fullNameKana: string;
  };
  discounts: {
    discountAmount: number;
    discountDiv: string;
    discountName: string;
  }[];
  isUpdatedByJira: boolean | null;
  isUpdatedByAdmin: boolean;
  language: string;
  roomDetails: {
    roomName: string;
    roomTypeCode: string;
    amenities: {
      highSpeedInternet: boolean;
      privateBathroom: boolean;
      toilet: boolean;
    };
    roomImageUrl: string[];
    bedTypeCode: string;
  };
  hotel: {
    name: string;
    address: string;
    propertyId: string;
  };
  plans: Plan[];
  affiliate: {
    a8?: string;
  };
  authToken: string;
}>;

const createBooking = async (data: RequestData) => {
  // eslint-disable-next-line no-console
  console.debug(`CALLING POST BOOKING API`, JSON.stringify(data));
  const result = await request<ResponseData>({
    url: `${process.env.NEXT_PUBLIC_BFF_URL}/bookings`,
    method: 'POST',
    data,
  });

  return result;
};

export default createBooking;
